import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';

import image1 from '../images/2016.jpeg'; // Import your images here
import image6 from '../images/2022.jpg';
import image7 from '../images/2023.jpg';
import image8 from '../images/2017.jpeg';
import image9 from '../images/2018.jpeg';
import image10 from '../images/2019.jpeg';

function GridExample() {
  return (
    <center>
      <Container className="mt-5">
        <Row xs={1} md={2} lg={3} className="g-4 justify-content-center custom-row">
          {[
            { image: image1, title: 'hackX 1.0 - 2016', link: 'https://www.facebook.com/share/aqQyxrYiNU3TYo8c/?mibextid=oFDknk' },
            { image: image8, title: 'hackX 2.0 - 2017', link: 'https://www.facebook.com/media/set/?set=a.1119266898205079&type=3&_rdc=1&_rdr' },
            { image: image9, title: 'hackX 3.0 - 2018', link: 'https://www.facebook.com/media/set/?set=a.2259550780783813&type=3&_rdc=1&_rdr' },
            { image: image10, title:'hackX 4.0 - 2019', link: 'https://www.facebook.com/media/set/?set=a.1715629315235498&type=3&_rdc=1&_rdr' },
            { image: image6, title: 'hackX 7.0 - 2022', link: 'https://www.facebook.com/media/set/?set=a.3660886667481109&type=3&_rdc=1&_rdr' },
            { image: image7, title: 'hackX 8.0 - 2023', link: 'https://www.facebook.com/nyouseeme/posts/pfbid02q2Kqux9JcQ58fgRkUzE6okHRmmDRZt6oRK5KmxKQmLMe62R9s9cfPCtAh69DiJbjl?_rdc=1&_rdr' },
          ].map((card, idx) => (
            <Col key={idx} className="mb-3">
              <a href={card.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <Card style={{ width: '18rem', position: 'relative', overflow: 'hidden', borderRadius: "25px" }}>
                  <div style={{ height: '200px', width: '100%', overflow: 'hidden' }}>
                    <Card.Img
                      variant="top"
                      src={card.image}
                      style={{
                        height: '100%',
                        width: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>
                  <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    color: 'white',
                    textAlign: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    padding: '10px',
                    transition: 'all 0.3s ease',
                    fontFamily: 'proxima_nova_rgregular',
                    fontOpticalSizing: 'auto',
                    fontWeight: 400,
                    fontStyle: 'normal',
                  }}
                    className="card-title-overlay">
                    <h5>{card.title}</h5>
                  </div>
                  <style>
                    {`
                      .card:hover .card-title-overlay {
                        top: 50%;
                        transform: translateY(-50%);
                        bottom: auto;
                      }

                      .card:hover h5 {
                        margin-top: 30px;
                      }

                      @media (min-width: 778px) and (max-width: 1000px) {
                        .custom-row {
                          display: flex;
                          flex-wrap: wrap;
                          justify-content: center;
                        }

                        .custom-row .col {
                          flex: 0 0 45%; /* Two columns for tablets */
                          max-width: 45%;
                          margin: 2.5%; /* Adjust the margin to keep columns centered */
                        }
                      }
                    `}
                  </style>
                </Card>
              </a>
            </Col>
          ))}
        </Row>
      </Container>
    </center>
  );
}

export default GridExample;
